<template>
  <div class="consent-container">
    <v-switch
      :input-value="value"
      @change="$emit('input', $event)"
      class="consent-switch"
    ></v-switch>
    <div class="consent-label">
      Вводя данные клиента, я подтверждаю, что получил согласие субъекта
      персональных данных (клиента или его законного представителя) на их
      передачу и обработку компанией ООО «Апмайнд+» в соответствии с
      <a href="/privacy" target="_blank">Политикой конфиденциальности</a>.
    </div>
  </div>
</template>

<script>
export default {
  name: "ConsentCheckbox",
  props: {
    value: Boolean,
  },
};
</script>

<style scoped>
.consent-container {
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.consent-switch {
  flex-shrink: 0;
}
.consent-label {
  margin-left: 8px;
  font-size: 0.8rem;
}
</style>
